import { Box, styled } from '@mui/material';

export const FooterContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.colors.footerBackground,

  [theme.breakpoints.up('lg')]: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

export const FooterInnerContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    width: '869px',
  },
  [theme.breakpoints.up('xxl')]: {
    width: '1196px',
  },
  [theme.breakpoints.up('xxxxl')]: {
    width: '1408px',
  },
}));
